import { render } from "./index.vue?vue&type=template&id=4dad4bbe&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=4dad4bbe&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/kj-wx-web-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dad4bbe"]])

export default __exports__